import { useContext } from 'react';
import CourseContext from '../../contexts/courseContext';

type CourseStatuses = {
  isFinished: boolean;
  hasAlreadyFollowed: boolean;
  notStarted: boolean;
  isFollowing: boolean;
};
export type UseCourseStatus = () => CourseStatuses;

const useCourseStatus: UseCourseStatus = () => {
  const { course, currentUser } = useContext(CourseContext);
  const {
    userCourseCompletionRate: progression,
    userHasFollowedCourse,
    userIsFollowingCourse,
  } = course;

  const isFinished = progression === 100;

  const hasAlreadyFollowed =
    !isFinished && currentUser && userHasFollowedCourse && !userIsFollowingCourse;

  const notStarted =
    !isFinished && (!currentUser || (!userHasFollowedCourse && !userIsFollowingCourse));

  const isFollowing = !isFinished && currentUser && userIsFollowingCourse;

  return {
    isFinished,
    hasAlreadyFollowed,
    notStarted,
    isFollowing,
  };
};

export default useCourseStatus;
